import { Injectable, inject } from '@angular/core';

import { AdvertiserEdit, AdvertiserEntitiesResponse } from '@rp/shared/models';
import {
  ADVERTISER_ENTITIES_PROVIDER_TOKEN,
  AdvertiserEntitiesProvider,
} from '@rp/shared/providers';
import { Observable } from 'rxjs';

@Injectable()
export class AdvertiserEntitiesService implements AdvertiserEntitiesProvider {
  private readonly _advertiserEntitiesProvider = inject(ADVERTISER_ENTITIES_PROVIDER_TOKEN);

  getAdvertiserEntities(params: string): Observable<AdvertiserEntitiesResponse> {
    return this._advertiserEntitiesProvider.getAdvertiserEntities(params);
  }

  getAdvertiserEntity(id: number): Observable<AdvertiserEdit> {
    return this._advertiserEntitiesProvider.getAdvertiserEntity(id);
  }
}
